import React from 'react';
import './App.scss';
import {AppRouter} from "./modules/app/router/component/AppRouter";
import {ThemeProvider} from '@material-ui/core';
import GLOBAL_THEME from "./GlobalCssTheme";
import {AppSnackbar} from "./modules/snackbar/component/app/AppSnackbar";
import {BrandProvider} from "./modules/brand/BrandContext";

function App() {

    return (
        <div id="payment-page-wrapper">
            <BrandProvider>
                <ThemeProvider theme={GLOBAL_THEME}>
                    <AppSnackbar/>
                    <AppRouter/>
                </ThemeProvider>
            </BrandProvider>
        </div>
    );
}

export default App;
